// helpers.ts -- Pure utility functions for PW2202 (Purchase Return)

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) [T-F02] */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string [T-F02] */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Format number as integer (no decimals) for tax amount */
export const fmtInt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 0 });
};

/** Get status badge for approval status (F2120_80) */
export const getStatusBadge = (record: { f2120_80?: string } | null): { text: string; cls: string } | null => {
  if (!record) return null;
  const s80 = (record.f2120_80 || '').trim();
  if (s80 === 'P') return { text: '已核准', cls: 'badge-success' };
  return null;
};

/** Check if record is locked (approved, cannot edit/delete) */
export const isApproved = (record: { f2120_80?: string } | null): boolean => {
  if (!record) return false;
  return (record.f2120_80 || '').trim() === 'P';
};

/**
 * Calculate detail amount = qty * price, ROUND to 2 decimals
 * Frontend auto-calc for immediate display; backend is source of truth.
 */
export const calcDetailAmount = (qty: number, price: number): number => {
  return Math.round(qty * price * 100) / 100;
};

/**
 * Calculate totals for Tab3 display
 * subtotal = detailSum + transportation + freight
 * tax = ROUND(subtotal * 0.05, 0) if taxType=1 (含稅), else 0
 * grandTotal = subtotal + tax
 */
export const calcTotals = (
  detailSum: number, transportation: number, freight: number, taxType: number
): { subtotal: number; tax: number; grandTotal: number } => {
  const subtotal = detailSum + transportation + freight;
  const tax = taxType === 1 ? Math.round(subtotal * 0.05) : 0;
  const grandTotal = subtotal + tax;
  return { subtotal, tax, grandTotal };
};
